import { createContext } from "react";

//Contexto para el componente EditableRowTable y EditableCellTable de la tabla
export const EditableContext = createContext(null);